module.exports = __webpack_public_path__ + "img/img10.20779c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img10.jpg
// module id = 275
// module chunks = 0